// extracted by mini-css-extract-plugin
export default {"mainDiv":"MessagePopup_mainDiv__aqSRK","container":"MessagePopup_container__YuNmL","button":"MessagePopup_button__K7r47","buttonSecondary":"MessagePopup_buttonSecondary__1jv5h"};